import React from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { CustomerServiceHeader } from 'components/customer-support/customer-support-header.component';
import { CustomerSupportMasonrySection } from 'components/customer-support/customer-support-masonry-section.component';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { useCustomerSupport } from 'hooks/use-customer-support.hook';

const CustomerSupportPage = () => {
  const { formatMessage } = useIntl();
  useCustomerSupport(); // Analytics tracking

  const title = formatMessage({ id: 'STR_CUSTOMER_SUPPORT' });

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <HeroSection title={title} height="154px" />
      <StackLayout>
        <StackLayout
          css={{
            maxWidth: 952,
            marginBottom: '$four',
            alignItems: 'center',
            backgroundColor: '$surfaceCardSecondary',
            '@desktop': {
              padding: '40px 32px',
              boxShadow: '0px 2px 6px 0px #00000014',
            },
          }}
        >
          <CustomerServiceHeader />
          <CustomerSupportMasonrySection />
        </StackLayout>
      </StackLayout>
    </MainPageContainer>
  );
};

export default CustomerSupportPage;
